import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  CalendarDays,
  ChevronRight,
  Copy,
  Heart,
  MapPin,
  MessageCircle,
  Phone,
  Store,
  Tag,
} from "lucide-react";
import "./LikedStoresPage.css";

const LikedStoreDetails = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const store = {
    image: "../../assets/img/placeholder.png",
    storeName: "Urban Chic",
    address:
      "14th Main, 18th cross, 3rd Sector, Hsr Layout, Bangalore, 560102",
    contactNumber: "+91 8919180171",
    whatsappNumber: "+91 8919180171",
    offerCode: "SNM12345678CNDM",
  };

  const openDirections = () => {
    const query = encodeURIComponent(
      `${store.storeName}, ${store.address}`,
    );
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${query}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const openWhatsApp = () => {
    const number = store.whatsappNumber.replace(/\D/g, "");
    window.open(
      `https://wa.me/${number}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const copyOffer = async () => {
    try {
      await navigator.clipboard.writeText(store.offerCode);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1300);
    } catch {
      setCopied(false);
    }
  };

  return (
    <section className="liked-stores-page">
      <section className="liked-stores-mobile-detail">
        <header className="liked-stores-mobile-detail-header">
          <button
            type="button"
            onClick={() => navigate("/LikedStores")}
            aria-label="Back to liked stores"
          >
            <ArrowLeft size={19} strokeWidth={2.2} />
          </button>
          <div>
            <span>MY STUFF</span>
            <h1>Liked Store Details</h1>
          </div>
          <span className="liked-stores-mobile-detail-header-icon">
            <Store size={20} strokeWidth={2} />
          </span>
        </header>

        <div className="liked-stores-mobile-detail-stack">
          <section className="liked-stores-mobile-detail-card">
            <div className="liked-stores-mobile-detail-section-title">
              <span>
                <CalendarDays size={17} strokeWidth={2} />
              </span>
              <h2>Like Information</h2>
            </div>
            <div className="liked-stores-mobile-info-grid">
              <div>
                <span>Date</span>
                <strong>01-08-2025 (12:13 pm IST)</strong>
              </div>
              <div>
                <span>Status</span>
                <div className="liked-stores-status-actions">
                  <button type="button" className="liked active" disabled>
                    <Heart size={13} strokeWidth={2} />
                    Liked
                  </button>
                </div>
              </div>
            </div>
          </section>

          <section className="liked-stores-mobile-detail-card">
            <div className="liked-stores-mobile-detail-section-title">
              <span>
                <Store size={17} strokeWidth={2} />
              </span>
              <h2>Store Details</h2>
            </div>

            <div className="liked-stores-mobile-store-hero">
              <div className="liked-stores-mobile-store-image">
                <img src={store.image} alt={store.storeName} />
              </div>
              <div>
                <span>STORE</span>
                <h3>{store.storeName}</h3>
                <p>{store.address}</p>
              </div>
            </div>

            <div className="liked-stores-mobile-contact-list">
              <a href={`tel:${store.contactNumber.replace(/\s/g, "")}`}>
                <span>
                  <Phone size={17} strokeWidth={2} />
                </span>
                <div>
                  <small>Contact Number</small>
                  <strong>{store.contactNumber}</strong>
                </div>
                <ChevronRight size={18} />
              </a>
              <button type="button" onClick={openWhatsApp}>
                <span>
                  <MessageCircle size={17} strokeWidth={2} />
                </span>
                <div>
                  <small>WhatsApp Number</small>
                  <strong>{store.whatsappNumber}</strong>
                </div>
                <ChevronRight size={18} />
              </button>
              <button type="button" onClick={openDirections}>
                <span>
                  <MapPin size={17} strokeWidth={2} />
                </span>
                <div>
                  <small>Map</small>
                  <strong>Get Directions</strong>
                </div>
                <ChevronRight size={18} />
              </button>
            </div>
          </section>

          <section className="liked-stores-mobile-detail-card">
            <div className="liked-stores-mobile-detail-section-title">
              <span>
                <Tag size={17} strokeWidth={2} />
              </span>
              <h2>Offers</h2>
            </div>
            <div className="liked-stores-mobile-offer-card">
              <div>
                <span>OFFER CODE</span>
                <strong>{store.offerCode}</strong>
              </div>
              <button type="button" onClick={copyOffer}>
                <Copy size={16} strokeWidth={2} />
                {copied ? "Copied" : "Copy"}
              </button>
            </div>
          </section>
        </div>
      </section>
    </section>
  );
};

export default LikedStoreDetails;
